/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import {Box, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui';
import {RECENT_SEARCH_KEY} from '@salesforce/retail-react-app/app/constants';
import {searchUrlBuilder} from '@salesforce/retail-react-app/app/utils/url';
import {clearSessionJSONItem} from '@salesforce/retail-react-app/app/utils/utils';

const RecentSearches = ({recentSearches, closeAndNavigate}) => {
  const clearSearches = () => {
    clearSessionJSONItem(RECENT_SEARCH_KEY);
    closeAndNavigate(false);
  };

  return (
    <Box>
      {recentSearches?.length > 0 && (
        <Box>
          <Text data-testid="sf-suggestion-recent" fontSize="md" fontWeight="700">
            <FormattedMessage
              defaultMessage="Recent Searches"
              id="recent_searches.heading.recent_searches"
            />
          </Text>
          <Box mx="-16px">
            {recentSearches.map((recentSearch, idx) => (
              <Button
                key={idx}
                fontSize="md"
                name="recent-search"
                role="button"
                variant="menu-link"
                width="full"
                onMouseDown={() => {
                  closeAndNavigate(searchUrlBuilder(recentSearch));
                }}
              >
                <Text fontWeight="400">{recentSearch}</Text>
              </Button>
            ))}
            <Button
              data-testid="sf-clear-search"
              id="clear-search"
              variant="menu-link"
              width="full"
              onMouseDown={() => {
                clearSearches();
              }}
            >
              <Text color="blue.600" fontSize="md" fontWeight="400">
                <FormattedMessage
                  defaultMessage="Clear recent searches"
                  id="recent_searches.action.clear_searches"
                />
              </Text>
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

RecentSearches.propTypes = {
  recentSearches: PropTypes.array,
  closeAndNavigate: PropTypes.func,
};

export default RecentSearches;
